// ─── Label widths ─────────────────────────────────────────────────────────────

export const ROADMAP_LABEL_WIDTH = 280;
export const TASKS_LABEL_WIDTH = 340;
